     
<template>
  <div class="bg5 fl">
    <h1>学生德育 <span>{{(midCardObjList[0].data || 0)+(midCardObjList[1].data || 0)+""}}分</span></h1>
    <div class="content">
      <div class="fl">
        <div class="changgui">
          <h5>{{midCardObjList[0].name}}</h5>
          <img
            src='../../../assets/image/echarts/min_yuan1.png'
            alt="图片有误"
          >
          <h1>{{midCardObjList[0].data  || "0"}}<span>分</span></h1>
        </div>

      </div>
      <div class="fl">
        <div class="deyu">
          <h5>{{midCardObjList[1].name}}</h5>
          <img
            src='../../../assets/image/echarts/min_yuan2.png'
            alt="图片有误"
          >
          <h1>{{midCardObjList[1].data  || "0"}}<span>分</span></h1>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    midCardObjList:""
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.bg5 {
  width: 580px;
  height: 439px;
  background: url("../../../assets/image/echarts/bg4.png") no-repeat;
  margin-right: 20px;
  margin-bottom: 20px;
  h1 {
    height: 54px;
    line-height: 54px;
    font-size: 16px;
    font-weight: 500;
    padding-left: 15px;
    span {
      color: #597ef7;
      font-size: 22px;
      font-weight: 600;
      padding-left: 10px;
    }
  }
  .content {
    box-sizing: border-box;
    padding: 30px 20px;
    position: relative;
    left: 0;
    top: 0;
    .changgui,
    .deyu {
      box-sizing: border-box;
      margin-left: 50px;
      position: relative;
      h5 {
        box-sizing: border-box;
        height: 45px;
        border-bottom: 1px solid rgb(199, 193, 193);
        text-align: center;
        font-size: 24px;
        font-weight: 500;
        margin-bottom: 15px;
      }
      h1 {
        box-sizing: border-box;
        position: absolute;
        transform: translate(-50%, -50%);
        width: 150px;
        top: 55%;
        left: 45%;
        font-size: 60px;
        font-weight: 500;
        color: #fff;
        text-align: center;
        span {
          box-sizing: border-box;
          font-size: 15px;
          padding-left: 5px;
          color: #fff;
        }
      }
    }
  }
}
</style>

    